(function () {
  var header = document.querySelector('[data-header]');
  if (!header) return;

  /* Transparent over hero/product image -> solid once scrolled past it */
  if (header.classList.contains('header--overlay') || header.classList.contains('header--overlay-dark')) {
    var hero = document.querySelector('#MainContent .shopify-section');
    var firstImg = document.querySelector('.product__media-item');
    var threshold = 0;
    var ticking = false;

    /* Inverted (mix-blend) logo — product pages only.
       Built in JS (not in the section markup, which syncs unreliably) and
       appended to <body> so it lives in the ROOT stacking context and its
       mix-blend-mode: difference blends against the product photo behind the
       transparent header. The source is the already-rendered header logo,
       forced to pure white in CSS, so each letter inverts the colour behind it. */
    var blend = null, blendImg = null, srcLogo = null;
    if (header.classList.contains('header--overlay-dark')) {
      srcLogo = header.querySelector('.header__logo-img--dark')
             || header.querySelector('.header__logo-img')
             || header.querySelector('.header__logo img');
      blend = document.querySelector('.header__blend-logo');
      if (!blend && srcLogo) {
        blend = document.createElement('div');
        blend.className = 'header__blend-logo';
        blend.setAttribute('aria-hidden', 'true');
        blendImg = document.createElement('img');
        blendImg.className = 'header__blend-logo-img';
        blendImg.alt = '';
        blend.appendChild(blendImg);
      }
      if (blend) {
        blendImg = blend.querySelector('img') || blendImg;
        if (blendImg && srcLogo && !blendImg.getAttribute('src')) {
          blendImg.src = srcLogo.currentSrc || srcLogo.src;
        }
        document.body.appendChild(blend); /* relocate into the root stacking context */
        header.classList.add('header--blend');
      }
    }
    function sizeBlend() {
      if (!blend || !blendImg || !srcLogo) return;
      var w = srcLogo.getBoundingClientRect().width;
      if (!w) w = parseInt(srcLogo.style.width, 10) || 160;
      blendImg.style.width = w + 'px';
    }

    function calc() {
      var ref = firstImg || hero;
      threshold = ref ? Math.max(0, ref.offsetHeight - header.offsetHeight) : 0;
    }
    function update() {
      var solid = window.scrollY > threshold;
      header.classList.toggle('is-solid', solid);
      if (blend) document.body.classList.toggle('blend-solid', solid);
      ticking = false;
    }
    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    calc();
    sizeBlend();
    update();
    if (blendImg) blendImg.addEventListener('load', sizeBlend);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { calc(); sizeBlend(); update(); }, { passive: true });
  }

  /* Mobile menu */
  var toggle = header.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-mobile-menu]');
  if (toggle && menu) {
    var closeTimer = null;
    function setOpen(open) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) {
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
        menu.hidden = false;
        void menu.offsetWidth; /* reflow so the transition runs */
        menu.classList.add('is-open');
      } else {
        menu.classList.remove('is-open');
        closeTimer = setTimeout(function () { menu.hidden = true; }, 400);
      }
    }
    toggle.addEventListener('click', function () { setOpen(menu.hidden); });
    menu.querySelectorAll('[data-menu-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { setOpen(false); });
    });
    menu.addEventListener('click', function (e) {
      if (e.target === menu) setOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !menu.hidden) setOpen(false);
    });

    /* Expandable sub-menus (the "+" groups) */
    menu.querySelectorAll('[data-submenu-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        var sub = btn.nextElementSibling;
        if (sub) sub.hidden = expanded;
      });
    });
  }
})();
